// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import {getAuth} from 'firebase/auth'
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDKu65Wu9_6lP7U5FEAu7UN_PW59E0_bjQ",
  authDomain: "loginpage-1169a.firebaseapp.com",
  projectId: "loginpage-1169a",
  storageBucket: "loginpage-1169a.appspot.com",
  messagingSenderId: "872084678994",
  appId: "1:872084678994:web:d11a396704138bf118328b"
};
const app=initializeApp(firebaseConfig)
const auth=getAuth(app)
// Initialize Firebase
export {auth}